module.exports = __webpack_public_path__ + "img/logopnb.f79c639c.jpg";